import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoService } from '../../../../../services/video/video.service';

@Component({
  standalone: true,
  selector: 'app-video-list',
  imports: [CommonModule],
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.css']
})
export class VideoListComponent {

  // TEST_VIDEO_URL = "https://dev-us-east-2-ur-innovation-service-manual-tool-bucket.s3.amazonaws.com/videos_by_type/DOUGLAS/z3020n/2023/Video2.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZDZTBT42HJ2J5MEH%2F20260312%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260312T195454Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMiJHMEUCIDHIoNYDH7wUmCzkPyabwHHxUIPcR04q09EkaJQxJNzGAiEA4QaGLIIV8E6MR3UbQYq%2BjelqGwzLdwW77UVVN5pUfyIq%2FwIIexAAGgw2MjY2MzU0MTUzNDgiDPzy6x6nRjztzHAsvCrcAvUUTfh27Prht0YNL3c02Gerw0qNK3QiIH%2BA2VxyaltMR14%2BM5i1CnFrQUT1Dc3BWytFUsv885Fs0vr%2FdjRgO5EQvuY1Wr4YIcQbzyBZJhGACiXsoOapEY%2Fk35HLJuTl4BP7vWhaQmt0bjvx3OGxpQXwNezGVybeTHPkvknguEie0YHpjaQbUqnRg01P0St9DEx2jcS4hgEoHOfSR0cWyRGtVYhw5PKdpaO6KE4VPo5HO7SBhePZZYiU3s8Mgor6x8LwYMLpWcEElU0GD8h6UA665VhSw5MYkNJ59D4Dj7W%2F9oWvMvYXVVQH4FBnZLzv5fXxnMsFB%2Bx4IhniCTq8TDrJlZcqXbljQB58Q9wu4rPW8I4QcWT7p6p35ZNtXxbD5puTk%2F%2BX%2FHq1Vw1MCp6nzQhDVmEiHHp3nFwhttTeI8MaiqZqToBUqz1t4QSdLHlhKzmcIsYNcpUcaxfzqTCI9MvNBjqlAWB2ohz%2F%2BA0nLQ8kHehNSShyMB3nFlujeFcAQjgo4alBdN%2FSN9XNlOoO3xoDOM5tYuTIc74tm717lsG73%2FS5QGHCdu3aSvkPUZX5m3w7B5r66XyFQ9SQPhFR5HzqYXVpaJpljA%2BApll4cxg9iRZuDAGIouTD8JlABprRBmPSE41eMd9WeR79YZ%2FNBvd727rprPInoXJN3%2BQdCZKdL12BEjz0qlPwrA%3D%3D&X-Amz-Signature=93584eeef4aa9f4d545fa473caf7d07e153547d2c5e8ca207f50402b8d8c993e" 
  // openVideo() {
  //   this.openVideoPopout(this.TEST_VIDEO_URL, 30); // starts at 30 seconds
  // }

  // openVideoPopout(url: string, startSeconds?: number) {
  //   const params = new URLSearchParams();
  //   params.set('src', url);
  //   if (startSeconds) {
  //     params.set('t', startSeconds.toString());
  //   }

  //   window.open(
  //     `/technician/video-player?${params.toString()}`,
  //     '_blank',
  //     `width=150,height=300,resizable=yes`
  //   );
  // }
  constructor(private videoService: VideoService) {}

  async openVideo(videoId: string) {
    const presignedUrl = await this.videoService.getPresignedUrl(videoId);
    this.openVideoPopout(presignedUrl, 60); // Start at 60 seconds example
  }

  openVideoPopout(url: string, startSeconds?: number) {
    const params = new URLSearchParams();
    params.set('src', url);
    if (startSeconds) {
      params.set('t', startSeconds.toString());
    }

    const width = 900;
    const height = 600;

    window.open(
      `/video-player?${params.toString()}`,
      '_blank',
      `width=${width},height=${height},resizable=yes`
    );
  }
}